import EnrolmentsAdapter from './base';

export default class Status extends EnrolmentsAdapter {
  modelNamePlural = 'status';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('statuses', 'status')
      .toLowerCase();
  }
}
